import { GREY } from '@/constants/color';
import { Close } from '@mui/icons-material';
import { Box, Button, Dialog, DialogContent, IconButton, dialogClasses } from '@mui/material';

interface IProps {
  open: boolean;
  onClose: () => void;
}

const ReportNoticeModal = ({ open, onClose }: IProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        [`& .${dialogClasses.scrollPaper}`]: {
          alignItems: 'flex-start',
          justifyContent: 'flex-end',
        },
      }}
    >
      <DialogContent
        sx={{
          display: 'flex',
          padding: '16px',
          maxWidth: '400px',
          gap: '16px',
          flexShrink: 0,
        }}
      >
        <Box
          sx={{
            color: '#27BE69',
          }}
        >
          <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <circle opacity='0.1' cx='16' cy='16' r='16' fill='currentColor' />
            <path
              d='M9.32102 15.5C9.27407 15.8428 9.24976 16.1933 9.24976 16.55C9.24976 20.5265 12.2718 23.75 15.9998 23.75C19.7277 23.75 22.7498 20.5264 22.7498 16.55C22.7498 16.1933 22.7254 15.8428 22.6785 15.5'
              stroke='currentColor'
              strokeWidth='1.5'
              strokeLinecap='round'
            />
            <path
              d='M15.9998 17.75L15.9998 10.25M15.9998 17.75C15.4746 17.75 14.4934 16.2543 14.1248 15.875M15.9998 17.75C16.5249 17.75 17.5061 16.2543 17.8748 15.875'
              stroke='currentColor'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </Box>
        <Box>
          <p className='font-semibold text-[14px]'>Your report is currently loading.</p>
          <p className={`text-[14px] text-[${GREY}]`}>
            You will get an email when your export is ready, or you can return to this screen at any time, and check the
            Recent Exports section.
          </p>
          <Button disableRipple sx={{ padding: 0, minWidth: 0 }} onClick={onClose}>
            Dismiss
          </Button>
        </Box>
        <Box>
          <IconButton aria-label='close' onClick={onClose} sx={{ padding: 0 }}>
            <Close />
          </IconButton>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ReportNoticeModal;
